export const CHANGE_USER = 'auth.CHANGE_USER';
export const CHANGE_CORRECTLY = 'auth.CHANGE_CORRECTLY'